const SINGULAR_PROD_BASE_URL = "https://noom.sng.link/Ernae/qphf?_dl=noom";
const SINGULAR_TEST_BASE_URL =
  "https://noom.sng.link/Equ5d/rqnk/vs04?_dl=noomtest";

const SINGULAR_BASE_URL =
  window.ENV.NOOM_ENVIRONMENT === "production"
    ? SINGULAR_PROD_BASE_URL
    : SINGULAR_TEST_BASE_URL;

export const buildDeeplink = (email?: string) => {
  const uri = email
    ? `://noom.com?open=HOME&email=${email}`
    : "://noom.com?open=HOME";

  const encodedUri = encodeURIComponent(uri);

  return `${SINGULAR_BASE_URL}${encodedUri}`;
};
